import application from 'application/application';

application.directive('ngMinLength', () => ({
	require: 'ngModel',
	scope: {
		ngMinLength: '='
	},
	link(scope, element, attrs, controller) {
		controller.$validators.MinLength = modelValue => {
			const acceptEmpty = attrs.ngAcceptEmpty || true;

			if (acceptEmpty !== 'false') {
				if (controller.$isEmpty(modelValue) || !scope.ngMinLength) return true;
			}

			return controller.$isEmpty(modelValue)
				? false
				: modelValue.length >= scope.ngMinLength;
		};
	}
}));
